import BTable from './BTable';
export default BTable;
